
import { CONSTANTS } from "../../constants";

export default {
  name: "EcommerceProductPage",
  data: () => ({
    BANNER_DETAILS: CONSTANTS.ECOMMERCE_BANNER_DETAILS,
    CLIENT_LOGOS: CONSTANTS.CLIENT_LOGOS,
    CLIENT_LOGOS_WITH_TEXT: CONSTANTS.CLIENT_LOGOS_WITH_TEXT,
    REVIEWS: CONSTANTS.REVIEWS,
    features: [
      {
        name: "Custom E-commerce Mobile App",
        description:
          "Elevate your online business with a custom-built mobile app that reflects your brand identity and caters to your specific business needs.              Our expert team specializes in crafting intuitive and visually stunning e-commerce mobile applications that engage your customers and drive conversions. Whether you're a budding startup or an established enterprise, our tailored solutions ensure seamless integration with your existing systems and a user experience that keeps customers coming back for more.",
        imageName: "ecommerce-ft1.png",
      },
      {
        name: "Custom E-commerce Web App",
        description:
          "Take your online store to new heights with a custom-built web application designed to enhance user experience and boost sales. Our team of skilled developers works closely with you to understand your business objectives and deliver a web app that not only meets but exceeds your expectations. From intuitive navigation to seamless checkout processes, we ensure every aspect of your e-commerce website reflects your brand identity and keeps customers coming back for more.",
        imageName: "ecommerce-ft2.png",
      },
      {
        name: "Unified Admin Panel",
        description:
          "Simplify the management of your online store with our unified e-commerce admin panel. Gain complete control over your inventory, orders, and customer data from a single, easy-to-use dashboard. Our comprehensive solution empowers you to streamline operations, track performance, and make informed decisions to drive business growth. Our admin panel provides the tools you need to succeed in today's competitive e-commerce landscape.",
        imageName: "ecommerce-ft3.png",
      },
    ],
  }),
  mounted() {
    if (window.innerWidth > 600)
      this.CLIENT_LOGOS = this.CLIENT_LOGOS_WITH_TEXT;
  },
  head() {
    return {
      title: "Ecommerce solutions by AiBuddha",
      description:
        "Connect with your customer where it matters the most to them. Let our AI take care of the heavy lifting while people work on planning growth strategies.",
    };
  },
};
